import React, { Component } from "react";

export default class NestedModuleTile extends Component {
  render() {
    const { title, initialLink, isActive, hideTile } = this.props;

    return (
      <li
        className={isActive ? "active" : ""}
        style={{
          display: hideTile ? "none" : "block",
        }}
      >
        <a href={initialLink} className="sideText">
          {title}
        </a>
        <ul className="nav nav-third-level collapse">{this.props.children}</ul>
      </li>
    );
  }
}
